"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _inputs = require("@vds-core/inputs");

var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");

var _typography = require("@vds/typography");

var typescale = _typography.TypographyConfig.getTypescale();

function _calculateFocusSize(size) {
  return (0, _javascriptStyleHelpers.calculateRem)(size + 6);
}

function _determineSwatchMargin() {
  return "".concat((0, _javascriptStyleHelpers.calculateRem)(0), " auto ").concat((0, _javascriptStyleHelpers.calculateRem)(8));
}

var RadioSwatchGroup = function RadioSwatchGroup(props) {
  return /*#__PURE__*/_react["default"].createElement(_inputs.RadioSwatchGroup, (0, _extends2["default"])({}, props, {
    bodyConfig: _typography.BodyConfig,
    typescale: typescale,
    typographyConfig: _typography.TypographyConfig,
    focusSize: _calculateFocusSize,
    focusState: true,
    selectedStateDoubleBorder: true,
    labelMargin: 4,
    labelMaxWidth: 120,
    labelMinWidth: 44,
    swatchMargin: _determineSwatchMargin,
    size: 26,
    disabledState: false
  }));
};

var _default = RadioSwatchGroup;
exports["default"] = _default;